import { render, staticRenderFns } from "./v1.vue?vue&type=template&id=4b1c3894&scoped=true&"
import script from "./v1.vue?vue&type=script&lang=js&"
export * from "./v1.vue?vue&type=script&lang=js&"
import style0 from "./v1.vue?vue&type=style&index=0&id=4b1c3894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c3894",
  null
  
)

export default component.exports